<template>
  <section class="press-content" id="press">
    <div class="press-header">
      <h2>Press & Content Creators</h2>
      <hr />
    </div>
    <div class="press-info">
      <div class="press-child">
        <div class="press-child-img">
          <img
            src="/static/assets/images/scroll-quill.svg"
            alt="scroll quill"
          />
        </div>
        <h5>Press Contact</h5>
        <p>
          For any specific press related enquiries please use the link below.
          We'd love to hear from you.
        </p>
        <a href="mailto:contact@halfhumangames.com">Email Us</a>
      </div>
      <div class="press-child">
        <div class="press-child-img">
          <img src="/static/assets/images/key.svg" alt="key" />
        </div>
        <h5>Review Copies</h5>
        <p>
          You are welcome to request keys! Make sure to mention the platform and region in the email.
        </p>
        <a href="mailto:contact@halfhumangames.com" target="_blank"
          >Request key</a
        >
      </div>
      <div class="press-child">
        <div class="press-child-img">
          <img
            src="/static/assets/images/locked-chest.svg"
            alt="locked chest"
          />
        </div>
        <h5>Press Kit</h5>
        <p>
          To access our full presskit please use the link below. If you need
          anything else just contact us.
        </p>
        <a
          href="https://drive.google.com/drive/folders/1VXbDYqRwq8Yp6M4txVMKSJy8X3SCiZLh?usp=sharing"
          target="_blank"
          >Press Kit</a
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
section.press-content {
  background: url(/static/assets/images/Dwerve-Brick-Texture.png);
  padding: 90px 0px;
  visibility: visible;
  top: 0;
  position: relative;
}

.press-child-img {
  text-align: center;
}
.press-child-img img {
  height: 89px;
  width: 74px;
  -webkit-filter: drop-shadow(0 0 0.75rem #5fc3db);
  filter: drop-shadow(0 0 0.75rem #5fc3db);
  padding-bottom: 15px;
}

.press-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.press-header h2 {
  font-family: Grandmaster;
  line-height: 1.4;
  z-index: 1;
  font-size: 40px;
  color: #ffffff;
  text-align: center;
  text-shadow: -2.4px -2.4px 0 #1d1a44, -2.4px -1.4px 0 #1d1a44,
    -2.4px -0.4px 0 #1d1a44, -2.4px 0.6px 0 #1d1a44, -2.4px 1.6px 0 #1d1a44,
    -2.4px 2.6px 0 #1d1a44, -1.4px -2.4px 0 #1d1a44, -1.4px -1.4px 0 #1d1a44,
    -1.4px -0.4px 0 #1d1a44, -1.4px 0.6px 0 #1d1a44, -1.4px 1.6px 0 #1d1a44,
    -1.4px 2.6px 0 #1d1a44, -0.4px -2.4px 0 #1d1a44, -0.4px -1.4px 0 #1d1a44,
    -0.4px -0.4px 0 #1d1a44, -0.4px 0.6px 0 #1d1a44, -0.4px 1.6px 0 #1d1a44,
    -0.4px 2.6px 0 #1d1a44, 0.6px -2.4px 0 #1d1a44, 0.6px -1.4px 0 #1d1a44,
    0.6px -0.4px 0 #1d1a44, 0.6px 0.6px 0 #1d1a44, 0.6px 1.6px 0 #1d1a44,
    0.6px 2.6px 0 #1d1a44, 1.6px -2.4px 0 #1d1a44, 1.6px -1.4px 0 #1d1a44,
    1.6px -0.4px 0 #1d1a44, 1.6px 0.6px 0 #1d1a44, 1.6px 1.6px 0 #1d1a44,
    1.6px 2.6px 0 #1d1a44, 2.6px -2.4px 0 #1d1a44, 2.6px -1.4px 0 #1d1a44,
    2.6px -0.4px 0 #1d1a44, 2.6px 0.6px 0 #1d1a44, 2.6px 1.6px 0 #1d1a44;
  margin-top: 0;
}

.press-child {
  max-width: 490px;
  padding: 20px 55px;
}

.press-child p {
  color: #fff;
  font-size: 16px;
}
.press-child h5 {
  color: rgb(46 165 244);
  font-size: 16px;
  text-shadow: 2px 2px #080808;
  padding: 0 0 5px;
  font-family: Grandmaster;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 1.4;
  font-weight: 400;
}

.press-child a {
  appearance: none;
  background-color: #fafbfc;
  border: 1px solid rgba(27, 31, 35, 0.15);
  border-radius: 6px;
  box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0,
    rgba(255, 255, 255, 0.25) 0 1px 0 inset;
  box-sizing: border-box;
  color: #24292e;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, system-ui, "Segoe UI", Helvetica, Arial,
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  list-style: none;
  padding: 6px 16px;
  position: relative;
  transition: background-color 0.2s cubic-bezier(0.3, 0, 0.5, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: middle;
  white-space: nowrap;
  word-wrap: break-word;
}

.press-child a:hover {
  background-color: #f3f4f6;
  text-decoration: none;
  transition-duration: 0.1s;
}

.press-child a:disabled {
  background-color: #fafbfc;
  border-color: rgba(27, 31, 35, 0.15);
  color: #959da5;
  cursor: default;
}

.press-child a:active {
  background-color: #edeff2;
  box-shadow: rgba(225, 228, 232, 0.2) 0 1px 0 inset;
  transition: none 0s;
}

.press-child a:focus {
  outline: 1px transparent;
}

.press-child a:before {
  display: none;
}

.press-child a:-webkit-details-marker {
  display: none;
}

.press-header hr {
  max-width: 1280px;
  border-top: 2px solid #21262a;
  margin-top: 12px;
  margin-bottom: 20px;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/PressContent.vue